import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let locationIds = new Set(
      data.tasks_boards.flatMap(board => board.metadata)
    )

    return data.session_user_locations.filter(loc => locationIds.has(loc._id))
  }, [data])
}
